export enum SavedViewsType {
  Screens = 'screens',
  Views = 'views',
  DefaultScreens = 'defaultScreens',
}
